import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DToastBody({ children, className, style }) {
    return (_jsx("div", { className: classNames('toast-body', className), style: style, children: children }));
}
//# sourceMappingURL=DToastBody.js.map